<template>
  <mt-popup v-model="moduleState.createRole" :modal=false popup-transition="popup-fade" class="page-module">
    <app-header v-bind="headerConfig"></app-header>
    <a href="javascript:;" class="save-btn" @click="saveRole">保存</a>

    <div class="content">
      <div class="set-role-container">
        <div class="cover fl">
          <img v-if="createRole.coverName" :src="getRoleImg('cover', true)" :alt="createRole.name"
               class="role-pic-small">
          <img v-else :src="getRoleImg('cover', false)" :alt="createRole.name" class="role-pic-small">
          <span class="sex" :class="createRole.gender" v-text="createRole.gender  ==='man'? '男性': '女性'"></span>
        </div>
        <div class="set-detail">
          <div class="edit-name">
            <input type="text" placeholder="角色名称" class="role-name" v-model.trim="createRole.name">
          </div>
          <div class="introduce">
            <textarea name="role-introduce" placeholder="角色介绍（非必填）" v-model="createRole.desc"></textarea>
          </div>
        </div>
      </div>
      <div class="portrait">
        <img v-if="createRole.coverName" :src="getRoleImg('painting', true)" :alt="createRole.name" class="role-pic">
        <img v-else :src="getRoleImg('painting', false)" :alt="createRole.name" class="role-pic">

        <a href="javascript:;" class="change-pic" @click="changePic">更换形象</a>
      </div>
      <role-material v-if="moduleState.ROLE_PIC_MATERIAL"></role-material>
    </div>
  </mt-popup>
</template>

<script>
  import {Toast} from 'mint-ui';
  import {mapState, mapMutations} from 'vuex';
  import store from '../store/store';
  import AppHeader from '../components/header';
  import RoleMaterial from '../components/material';
  import {ComponentName, Methods, CdnLibrary} from '../const/common';
  import {MaType, MaLib} from '../store/MaLib';

  export default {
    name: 'create_role',
    components: {
      'app-header': AppHeader,
      'role-material': RoleMaterial
    },
    computed: {
      watchRoleName() {
        return this.createRole.name;
      },
      ...mapState(['moduleState', 'createRole', 'storyRoles', 'stageRoles', 'defaultRolePic'])
    },
    data() {
      return {
        malib: new MaLib(this),
        headerConfig: {
          title: '角色创建',
          isStoryMenu: false,
          backNote: store.state.nextPageHeaderConf.createRole.backNote,
          backPage: store.state.nextPageHeaderConf.createRole.backPage,
          closeModule: ComponentName.CREATE_ROLE
        },
        cdnLibrary: CdnLibrary
      }
    },
    store,
    methods: {
      getRoleImg(type, real) {
        let _filter = '', _res = '', _prefix = '', _store = store.state;

        switch (type) {
          case 'cover':
            _filter = _store.roleHeadFlag;
            break;
          case 'painting':
            _filter = _store.roleThoraxFlag;
            _prefix = 'half/';
            break
        }

        if (_filter !== '') {
          let _sort = null, _style = Middle.ProjectData.header.style;

          _style = _style > 2 || _style < 0? 0: _style;
          _sort = real ? this.createRole.coverName : this.defaultRolePic[this.createRole.gender + '_' + _style];
          _sort.forEach(function (item) {
            if (item.indexOf(_filter) > -1) {
              try {
                _res = Middle.ResMap.getNameURL(_prefix + item,_prefix=="");
              } catch(e) {}
              return;
            }
          });
        }
        return _res;
      },
      changePic() {
        Methods.cutComponent([ComponentName.ROLE_PIC_MATERIAL], true);
        Methods.checkChapterHash(61);
      },
      saveRole() {
        let config = this.createRole, covers;

        if (!config.name || config.name === '') {
          return alert('请输入角色名');
        }

        if (!store.state.createRole.coverName) {
          let filtrate = this.createRole.gender + '_' + Middle.ProjectData.header.style;

          store.state.createRole.coverName = store.state.defaultRolePic[filtrate];
          covers = store.state.defaultRolePicToCanvas[filtrate];
        } else {
          let _coverNameRs = store.state.createRole.coverNameRs;

          if (_coverNameRs) {
            covers = Middle.ResMap.getMd5NameList(_coverNameRs);
          } else {
            covers = store.state.createRole.coverNameFull;
          }
        }

        if (config.isChange) {
          Middle.MiddleCommand.editorCharacter(config.id, config.name, covers, config.desc, config.gender);

          for (let i = 0; i < this.storyRoles.length; i++) {
            this.storyRoles[i].act = false;
          }
          // store.commit('editStorySetout');
        } else {
          Middle.MiddleData.AddCharacter(config.name, covers, config.desc, config.gender);
          // store.commit('editStorySetout');
        }
        store.commit('initStateCreateRole');
        Methods.cutComponent([store.state.nextPageHeaderConf.createRole.backPage], true);
        Methods.cutComponent([ComponentName.CREATE_ROLE], false);
        Methods.checkChapterHash(60);
      }
    },
    watch: {
      watchRoleName() {
        this.createRole.name =  this.createRole.name.replace(store.state.emoReg, '');
      }
    }
  }
</script>

<style scoped>
  @import "../style/css/create_role.css";
</style>



// WEBPACK FOOTER //
// src/components/create_role.vue